import React from "react";
import { DatePicker, ConfigProvider } from "antd";
import { RangePickerProps } from "antd/es/date-picker";

const { RangePicker } = DatePicker;

interface CustomDateRangePickerProps extends Omit<RangePickerProps, "picker"> {
  placeholder?: [string, string];
  format?: string;
  showTime?: boolean;
  showSecond?: boolean;
  showNow?: boolean;
  allowClear?: boolean;
  autoFocus?: boolean;
  inputReadOnly?: boolean;
  bordered?: boolean;
  size?: "large" | "middle" | "small";
  style?: React.CSSProperties;
}

const CustomDateRangePicker: React.FC<CustomDateRangePickerProps> = ({
  placeholder = ["Start Date", "End Date"],
  format = "DD-MM-YYYY HH:mm",
  showTime = true,
  showSecond = false,
  showNow = false,
  allowClear = true,
  autoFocus = false,
  inputReadOnly = false,
  bordered = true,
  size = "middle",
  style = { width: "100%" },
  ...restProps
}) => {
  return (
    <RangePicker
      showTime={showTime}
      format={format}
      showSecond={showSecond}
      showNow={showNow}
      placeholder={placeholder}
      style={style}
      allowClear={allowClear}
      autoFocus={autoFocus}
      inputReadOnly={inputReadOnly}
      bordered={bordered}
      size={size}
      {...restProps}
    />
  );
};

export default CustomDateRangePicker;
